import { render, staticRenderFns } from "./ClientGroupsMembersList.vue?vue&type=template&id=2bb2c5be&scoped=true&"
import script from "./ClientGroupsMembersList.vue?vue&type=script&lang=js&"
export * from "./ClientGroupsMembersList.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupsMembersList.vue?vue&type=style&index=0&id=2bb2c5be&lang=scss&scoped=true&"
import style1 from "./ClientGroupsMembersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2c5be",
  null
  
)

export default component.exports